<template>
<div>
  <div class="card-wrapper">
   
    <el-card class="box-card">

       
      <div slot="header" class="clearfix headerNav">
       
        <span class="card-header-text">{{gets('$商城')}}</span>
        <el-button style="float: right; padding: 3px 0" type="text"><i class="el-icon-shopping-cart-full" @click="showShoppingList" style="font-size:33px;cursor:pointer;"></i> </el-button>
        
      </div>
    
      <!-- 搜索框开始 -->
      <div >
        <div class="search-wrapper">
          <input type="text" class="search-value-input" v-model="serachKey" placeholder="Enter keywords…" @keyup.enter="searchProduct(serachKey)">
          <!-- <select name="keyword" id="keyword" class="input-select">
            <option value="ProductName">Product Name</option>
            <option value="SourceUrl">Source Url</option>
          </select> -->
           <select name="keyword" id="keyword" class="input-select">
            <option value="CnName">{{gets('$中文名称')}}</option>
            <option value="EnName">{{gets('$英文名称')}}</option>
            <!-- <option value="SKU">SKU</option>
            <option value="SalesPrice">{{gets('$销售价')}}</option>
            <option value="PurchasePrice">{{gets('$采购价')}}</option> -->
          </select>
          <i class="el-icon-arrow-down arrow" style="pointer-events: none;display: flex;color:#fff;justify-content: center;align-items: center;background: #1976d2;padding-right: 10px"></i>
          <button class="btn btn-primary btn-group-right" @click="searchProduct(serachKey,event)">
            <i class="el-icon-search"></i>
          </button>
        </div>
      </div>
      <!-- 搜索框结束 -->

     
      
      <!-- 筛选类型开始 -->
      <div>
        <div class="type-wrapper">
          <div class="type-title"> Home</div>
          <div class="type-select">
            <div class="select-list"   v-for="(item,index) in ShoppingPage.typeList" :key="index"  >
              <i class="el-icon-success" :style="item.colorStyle" :class="currentSelectType==item.ID?'selectTypeClass':''"></i>
              <div v-if="language=='CN'" style="" :style="item.colorStyle" :class="currentSelectType==item.ID?'selectTypeClass':''" @click="selectType(index,item.ID)">{{item.CnName}}</div>
               <div v-else style="" :style="item.colorStyle" :class="currentSelectType==item.ID?'selectTypeClass':''" @click="selectType(index,item.ID)">{{item.EnName}}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 筛选类型结束 -->
      <!-- 切换卡片开始 -->
      <!-- <div>
        <div class="tabBar">
          <div class="" :class="currentTabID==cardID?'tab-child-link tab-child':'tab-child'" v-for="(cardItem,cardID) in tabBar" :key="cardID" @click="changeType(cardID)">
            <i :class="cardItem.iconClass"></i>
            <div>{{cardItem.cardName}}</div>
          </div>
        </div>
      </div> -->
      <!-- 切换卡片结束 -->
      <div style="">
          <div class="mall-product" v-for="(item,index) in productsList" :key="index" @click="showProductDetail(item.ID)">
            <div class="recommend-box">
                <div class="products">
                    <div class="products-mainpic">
                      <img :src="item.ProductUrl" alt="" style="visibility: visible;">
                    </div>
                    <div class="products-detail">
                      <div class="products-title">
                        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">{{item.EnName}}</font></font>
                        <br>
                      </div>
                      <div>                         
                        <div class="el-row" style="margin-left: -9px; margin-right: -9px;display: flex;align-items: center;">
                              <div class="el-col" style="padding-left: 9px; padding-right: 9px; font-size: 14px;">{{gets('$热度')}}:</div>
                               <div class="el-col" style="padding-left: 9px;padding-right: 9px;font-size: 15px;color: #f97442;">
                                 <el-rate
                                  v-model="item.Evaluate"
                                  disabled
                                  show-score
                                  text-color="#ff9900"
                                  score-template="{value}"
                                 >
                                </el-rate>
                                <!-- {{item.stock}} units in stock -->
                               </div>
                        </div>
                      </div>
                       <div>                         
                        <div class="el-row" style="margin-left: -9px; margin-right: -9px;display: flex;align-items: center;">
                              <div class="el-col" style="padding-left: 9px; padding-right: 9px; font-size: 14px;">{{gets('$库存')}}:</div>
                               <div class="el-col" style="padding-left: 9px;padding-right: 9px;font-size: 15px;color: #f97442;">
                                
                                {{item.Quantity}} {{gets('$剩余库存')}}
                               </div>
                        </div>
                      </div>
                      <!-- <div class="products-price" style="">
                        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">USD$ {{item.SalesPrice}}</font></font>
                      </div> -->
                      <div style="display:flex;justify-content: space-between;align-items: center;">
                         
                          <div class="recommend-ranking" style="display: flex;justify-content: flex-end;height:">
                            <div class="ranking-name" @click.prevent.stop = "showProductDetail(item.ID)">
                              <span class="ranking-name-txt">
                                <font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;" > {{gets('$添加到我的产品')}}</font>
                                </font>
                              </span> 
                            </div>
                          </div>
                          <div class="recommend-ranking">
                            <div class="" @click.prevent.stop = "showProductDetail(item.ID)">
                              <span class="ranking-name-txt">
                                <font style="vertical-align: inherit;">
                                  <font style="vertical-align: inherit;color: #c7864d;fProdnt-weight:700;" >{{gets('$创建采购单')}} </font>
                                </font>
                              </span>
                            </div>
                          </div>
                      </div>
                      
                       
                    </div>
                </div>
              
            </div>
          </div>
      </div>
      <div style="display:flex;width:100%;padding-top:50px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="1"
            :page-sizes="[20, 50, 100, 200,500]"
            :page-size="PageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="TotalCount">
          </el-pagination>
      </div>
          
    </el-card>
  </div>
    

  <!-- 产品详情弹窗 -->
  <el-dialog
  title="Product Description"
  :visible.sync="dialogVisible"
  width="65%"
  :before-close="handleClose">
  
    <div class="product-main-wrap">
        <div class="img-view-wrap" itemprop="image">
          <div class="aaa">
            <div class="" style="display:flex;">
              <div class="image-viewer" style="display:block">
                <div class="video-wrap"></div>
                <img :src="detailPic" id="poster" alt="产品详情图" v-if="detailPic">
                <div v-else style="width:450px;height:450px;"></div>
               
                <div>
                  <div class="showlast arrowBtn" @click="showLastPic()" style="z-index:2;"> < </div>
                    <div class="small-pic">
                      <span v-for="(item,index) in smallPic" :key="index" :style="currentImgID==index&&hiddenBorder&&'border: 2px solid red;'">
                        <img :src="Urlpath+item.img" alt="" @click="changeImg(item,index)">
                       
                      </span>
                      <div style="margin-top:30px;" class="videoWidth">
                          <video id="bigVideo" class="videoWidth" muted  v-if="ProductDetail.VideoUrl!==''" :src="Urlpath+ProductDetail.VideoUrl" controls>
                          {{gets('$您的浏览器不支持播放该视频！')}} 
                          </video>
                      </div>  
                      
                    </div>
                  
                  <div class="shownext arrowBtn" @click="showNextPic()"> > </div>
                </div>
              </div>
           
            
              <div class="product-info">
                <div class="product-title" itemprop="name">
                  <h1 class="product-title-text" >
                    <font style="vertical-align: inherit;">
                      <font style="vertical-align: inherit; font-size: 18px;">{{ProductDetail.EnName}}</font>
                    </font>
                  </h1>
                </div>
                <div class="split-line-thin"></div>
                <div class="el-row" style="margin-left: -9px; margin-right: -9px;display: flex;align-items: center;margin-bottom:15px;">
                              <div class="el-col" style="padding-left: 9px; padding-right: 9px; font-size: 14px;">{{gets('$热度')}}:</div>
                               <div class="el-col" style="padding-left: 9px;padding-right: 9px;font-size: 15px;color: #f97442;">
                                 <el-rate
                                  v-model="ProductDetail.Evaluate"
                                  disabled
                                  show-score
                                  text-color="#ff9900"
                                  score-template="{value}">
                                </el-rate>
                               
                               </div>
                               
                </div>
                 <div class="el-row" style="margin-left: -9px; margin-right: -9px;display: flex;align-items: center;">
                              <div class="el-col" style="padding-left: 9px; padding-right: 9px; font-size: 14px;">{{gets('$库存')}}:</div>
                               <div class="el-col" style="padding-left: 9px;padding-right: 9px;font-size: 15px;color: #f97442;">
                              
                                {{ProductDetail.Quantity}} {{gets('$剩余库存')}} 
                               </div>
                               
                </div>
                 <!-- <div class="products-price" style="padding: 20px 0px 40px 0px;">
                        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">USD$ {{ProductDetail.SalesPrice}}</font></font>
                  </div> -->
                  <!-- <div style="">
                        <font style="vertical-align: inherit;"><font style="vertical-align: inherit;">Monthly sales：200,000 pcs</font></font>
                  </div> -->
                 <div class="detailsWrapper">
                    <!-- <div class="detailsTitle">
                      规格
                    </div> -->
                    <div class="detailsCont">
                      <!-- <table>
                        <tbody>
                          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                              <tr style="height: 44px;line-height:44px;">
                                <td class="chooseBox"></td>
                                <td class="productImg">图片</td>
                                <td class="name">中文名称</td>
                                <td class="EnName">英文名称</td>
                                <td class="SKU">SKU</td>
                                <td class="price salePriceTable">销售价</td>
                                <td class="qulatity">库存</td>
                                <td class="qulatity">规格</td>
                              </tr>
                          </el-checkbox>
                       
                          <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
                            <el-checkbox v-for="(item,index) in ProductDetailsArr" :key="index" :label="city" >
                              <tr >
                                <td class="productImg tdHeight"><img :src="Urlpath+item.ProductUrlSingle" alt=""  @mouseover="showInPoster(item)" ></td>
                                <td class="name tdHeight">{{item.CnName}}</td>
                                <td class="EnName tdHeight">{{item.EnName}}</td>
                                <td class="SKU tdHeight">{{item.SKU}}</td>
                                <td class="price tdHeight">{{item.SalesPrice}}</td>
                                <td class="qulatity tdHeight">{{item.Quantity}}</td>
                                <td class="qulatity tdHeight">{{item.Specification}}</td>
                              </tr>
                            </el-checkbox>
                          </el-checkbox-group>
                          
                          
                       
                        </tbody>
                      </table> -->
                      <el-table
                        class="detailTable"
                        ref="multipleTable"
                        :data="ProductDetailsArr"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @row-click="on_select"
                        @selection-change="handleSelectionChange">
                        <el-table-column
                          type="selection"
                          width="50">
                        </el-table-column>
                        <el-table-column
                          :label= 'gets("$图片")'
                          width="60">
                          <template slot-scope="scope">                          
                              <img :src="Urlpath+scope.row.ProductUrlSingle" alt="" style="width: 34px;height: 34px"  @mouseover="showInPoster(scope.row)">
                            
                          </template>
                        </el-table-column>

                         <!-- show-overflow-tooltip -->
                        <el-table-column
                               
                        class-name="CnNameColumn"
                        prop="name"
                        :label= 'gets("$中文名称")'
                        show-overflow-tooltip
                        width="120">
                                       
                            <template slot-scope="scope" style="display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;">
                                <el-popover trigger="hover" placement="top">
                                  <p>{{ scope.row.CnName }}</p>
                                  <div slot="reference" class="name-wrapper" style="display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;">
                                   {{ scope.row.CnName }}
                                  </div>
                                </el-popover>                          
                        </template>                                 
                        </el-table-column>

                        <el-table-column
                          prop="address"
                          :label= 'gets("$英文名称")'
                          :show-overflow-tooltip="true">
                          <template slot-scope="scope" >
                           <el-popover trigger="hover" placement="top">
                                  <p>{{ scope.row.EnName }}</p>
                                  <div slot="reference" class="name-wrapper" style="display: -webkit-box;
                            -webkit-line-clamp: 2;
                            -webkit-box-orient: vertical;
                            overflow: hidden;">
                                   {{ scope.row.EnName }}
                                  </div>
                                </el-popover>
                          
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="address"
                          label="SKU"
                          show-overflow-tooltip>
                           <template slot-scope="scope">{{ scope.row.SKU }}</template>
                        </el-table-column>
                        <el-table-column
                          prop="address"
                          :label= 'gets("$销售价")'
                          show-overflow-tooltip>
                           <template slot-scope="scope">{{ scope.row.SalesPrice }}</template>
                        </el-table-column>
                        <el-table-column
                          prop="address"
                          :label= 'gets("$库存")'
                          show-overflow-tooltip>
                           <template slot-scope="scope">{{ scope.row.Quantity }}</template>
                        </el-table-column>
                        <el-table-column
                          prop="address"
                          :label= 'gets("$规格")'
                          show-overflow-tooltip>
                           <template slot-scope="scope">{{ scope.row.Specification }}</template>
                        </el-table-column>
                      </el-table>
                    </div>
                 </div>
                 <div style="display:flex;align-items: center;justify-content: flex-end;margin-top:70px;">
                      <div class="recommend-ranking" style="margin-right:50px;">
                          <div class="ranking-name" style="width:100%;padding:0px 30px;" @click="AddProduct()">
                                <span class="ranking-name-txt">
                                  <font style="vertical-align: inherit;">
                                    <font style="vertical-align: inherit;">{{gets('$添加到我的产品')}}</font>
                                  </font>
                                </span> <i class="ranking-arr">&nbsp;</i>
                              </div>
                          </div>
                          
                     
                      <div class="recommend-ranking">
                                  <div class="" @click.prevent.stop = "AddMallPurchase(SpecificationID)">
                                    <span class="ranking-name-txt">
                                      <font style="vertical-align: inherit;">
                                        <font  class="creatPur">{{gets('$创建采购单')}} </font>
                                      </font>
                                    </span>
                                  </div>
                                </div>
                 </div>
                </div>
               </div>
          </div>
             
        </div>
        
    </div>
   <div>
                      <h2 style="margin:50px 0px;color: #607d8b;">Product Description</h2>
                      <div v-html="ProductDetail.Content">
                      </div>
                      <br>
                      <p style="font-weight:bold;color: #607d8b;"> {{gets("$功能")}}：</p>
                      <p>{{ ProductDetail.Feature}}</p>
                      <br>
                      <p style="font-weight:bold;color: #607d8b;">{{gets('$描述')}}：</p>
                      <p>{{ProductDetail.ProductDesc}}</p>
                      <br>

                      <!-- <p>{{ProductDetail.}}</p>
                      <p>汽车电池：3.7V 200MAH</p>
                      <p>尺寸：15.9 * 7.5 * 4.6cm（变形前）14.65 * 9.65 * 9.8 cm（变形）</p> -->
                      <br>
                      
                    </div>
  <span slot="footer" class="dialog-footer">
   
  </span>
</el-dialog>



 <!-- 购物车选择产品 -->
          <el-dialog :visible.sync="IsShowShoppingCar" width="70%" :before-close="closeDialogSKU" :modal-append-to-body="true" :append-to-body="true" :title="g('$我的产品')">
            <el-row :gutter="20">
                    <div class="app-container">
                        <div class="filter-container">
                            <page-search-table :store="ShoppingPage" :fieldData="ShoppingPage.SearchEntity" class="page_search_table"></page-search-table>
                            <div class="clearfix"></div>
                            <div class="comd" style="float: right;">
                                <el-button class="filter-item" v-if="isSee" type="primary" @click="ShoppingPage.Table.OnPageChange(1,this)" icon="el-icon-search">{{gets('$查询')}}</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="page_content" id="page_content" style="padding:0px 30px;margin-top:30px;">
                        <!-- :resultData="$store.state[InventoryPage.GN('SearchInventory')]" -->
                        <l-table-page-view :isShowPagination="true" :resultData="$store.state[ShoppingPage.GN('SearchProduct')]"   :TableConfig="ShoppingPage.Table2"></l-table-page-view>
                    </div>
                   
            </el-row>
            <div slot="footer">
                <el-button type="success" size="large" @click="closeDialogSKU() ">{{gets('$取消')}}</el-button>
                                
            </div>
        </el-dialog>


<!-- 右下角推送新产品信息 -->
 <el-collapse-transition>
    <div class="pushProduct" v-show="showPushDialog">
        
          <el-card class="push-box-card">
          <div slot="header" class="clearfix">
            <span style="font-weight:bold;">{{gets('$上新产品')}}</span>
            <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
          </div>
          <div class="push-text">
            <div class="push-detail" v-for="(item,index) in newProductList" :key="index">
              <div class="num"><span class="square">{{index+1}}</span></div>
              <div style="display:flex;align-items:center;">
                <div> <img :src="Urlpath+item.ProductUrl" alt="" style="width:48px;height:48px;vertical-align: middle;margin-right: 10px;"> </div>
                <div class="productName">{{item.EnName}}</div>
                <!-- <div class="productPricie">￥ <span>2.00</span> </div> -->
              </div>
            </div>

            <!-- <div class="push-detail">
              <div class="num"><span class="square">2</span></div>
              <div style="display:flex;align-items:center;">
                <div> <img src="../../assets/img/product3.png" alt="" style="width:48px;height:48px;vertical-align: middle;margin-right: 10px;"> </div>
                <div class="productName">中国红围巾定制LOGO刺绣公司年会开业</div>
                <div class="productPricie">￥ <span>5.00</span> </div>
              </div>
            </div>

             <div class="push-detail">
              <div class="num"><span class="square">3</span></div>
              <div style="display:flex;align-items:center;">
                <div> <img src="../../assets/img/product2.png" alt="" style="width:48px;height:48px;vertical-align: middle;margin-right: 10px;"> </div>
                <div class="productName">同学聚会大红色围脖批发印字</div>
                <div class="productPricie">￥ <span>3.00</span> </div>
              </div>
            </div> -->

          </div>
        </el-card>
     
    </div>
   </el-collapse-transition>
</div>

    
</template>

<script>
    import {
        IsRights,
        Modulel,
        Permission,
        Clone,
        ToComponentData,
        CheckByConfig,
        ToSubmitData,
        $Urlpath,
        TableHiddenbing
    } from '@/config/config'
    import gets from '@/model/language'
    import { ProductRequest } from '@/request/Warehouse'
    import {
        InitShoppingPage
    } from '@/config/Warehouse/MyShoppingMallConfig.js'
    import { ProductTypeRequest } from '@/request/Warehouse'
    import {
        RemoveFieldItem
    } from '@/lf'
    var ProductStoreName;
    var ProductConfig;
    var self;
    export default {
        data() {
            return {
              dialogVisible: false,//产品详情弹窗
              value5:3.7,//评分
              productsList:[
               
              ],
              detailPic:'',//产品详情大图
              smallPic:[
              
              ],//产品多张缩略图
              currentImgID:0,//当前图片下标
              typeList:[
                {name:'Clothes'},
                {name:'Fashion'},
                {name:'Kitchen'},
                {name:'Toys'},
                {name:'Tools'},
                {name:'Beauty&Health'},
                {name:'Creative products with video'},
                {name:'More categories'},
              ],
              tabBar:[
                {cardName:"View all",iconClass:'el-icon-notebook-2'},
                {cardName:"Discounted products",iconClass:'el-icon-discount'},
                {cardName:"Best selling products",iconClass:'el-icon-magic-stick'},
              ],
              currentTabID:0,//tabBar切换卡下标
              currentSelectType:"",//分类选项点击
              serachKey:"",
              TotalCount:0,
              PageCount:0,
              PageSize:20,
              PageIndex:1,
              $Urlpath: window._$Urlpath,
              Urlpath: window._$Urlpath,
              ProductDetail:{},
              ProductTypeID:'',
              selectValue:"",
              IsShowShoppingCar:false,
              shoppingCarList:[],//购物车列表
              radio: '0',
              ProductDetailsArr:[],//详情多规格数组
              hiddenBorder:true,
              SpecificationID:0,//选中的规格ID
              SpecificationSKU:null,//选中的规格SKU
              newProductList:[],//推送列表
              showPushDialog:false,
          
              multipleSelection: []

            }
        },
        created() {
          
            this.init()
            this.GetMallListPage()
            this.getNewProduct()
            this.PageIndex = 1
            if(this.UserContext.UserType == 1){
              this.showPushDialog= true
            }
        },
        computed: {
              language() {
                return window.$.cookie('LanguagesTag')
              },
              UserContext() {
                return window.rootVue.$store.state.UserRights.UserContext;
              },
              ShoppingPage() {
                
                  return this.$store.state[ProductStoreName];
              },
              isAdd() {
                  return IsRights(Modulel.ProductManage, Permission.Add)
              },
              isSee() {
                  return IsRights(Modulel.ProductManage, Permission.See)
              },
              isUpdate() {
                  return IsRights(Modulel.ProductManage, Permission.Update)
              },
              TableSelectCheckbox() {
                  return this.$store.state[this.ShoppingPage.GN('TableSelectCheckbox')];
              },

          },
        methods: {
            on_select(val){//点击行选中复选框
                this.$refs.multipleTable.toggleRowSelection(val);
            },
            toggleSelection(rows) {
              if (rows) {
                rows.forEach(row => {
                  this.$refs.multipleTable.toggleRowSelection(row);
                });
              } else {
                this.$refs.multipleTable.clearSelection();
              }
            },
            handleSelectionChange(val) {
              this.multipleSelection = val;
              
            },
          handleCheckAllChange(val) {
            this.checkedCities = val ? ProductDetailsArr : [];
            this.isIndeterminate = false;
          },
          handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.cities.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
          },
          getNewProduct(){
             ProductTypeRequest.RightProductData(function(d) { 
                             
                                    self.newProductList = d.Procuct
                                    setTimeout(function(){ 
                                      self.showPushDialog = false 
                                    }, 8000);
                               
                            
                        }, {
                            top:3
                        })
          },
          getItem(item){
            this.SpecificationID=item.ID
            this.SpecificationSKU = item.SKU
            
          },
          showInPoster(item){
            this.hiddenBorder=false
            this.detailPic = this.Urlpath+ item.ProductUrlSingle
            
            this.smallPic.map(item2=>{
              if(item.ProductUrl==item2){
                alert(111)
              }
            })
            
          },
          AddMallPurchase(ID){
              this.dialogVisible = false
              var purchaseID = []
              if(this.multipleSelection.length==0){
                self.$message.error(gets("$请至少选择一个产品"))
                return
              }
              this.multipleSelection.map(item=>{
                  purchaseID.push(item.ID)
              })
              
               ProductTypeRequest.GetPurchasesDetailsByCart(function(d) {
                  //   let data = d.Records[0]
                 
                      localStorage.setItem("item",JSON.stringify(d))
                      localStorage.setItem("isNavAddMallPurchase",0)
                      self.$router.push('/AddMallPurchase/'+ID)
                     
                  
                  
                // vueObj.$set(vueState, GN("SearchProduct"), d)
                // state.Table.$TableRowButtons = null;
                // vueObj.$set(state.Table, '$TableRowButtons', state.Table.TableRowButtons())
                // vueObj.$set(state, 'Table', Clone(state.Table))
                //if (callback) { callback(d) }
            },  purchaseID)
          
           
          },
          showShoppingList(){
            this.IsShowShoppingCar = true;
            this.ShoppingPage.SearchPageData();
           
            // ProductTypeRequest.MallCartPaging(function(d) { 
            //                  if (d.Message == "OK") {
            //                         self.shoppingCarList = d.Records
            //                         self.$message.success(gets("$操作成功"))
            //                     } else {
            //                         self.$message.error(d.Message)
            //                     }
                            
            //             }, {
            //                 PageSize:100,
            //                 PageIndex:1
            //             })
          },
          closeDialogSKU(){
                this.IsShowShoppingCar = false;

            },
          init() {
                window.rootVue.setThisWindowVueComponent(this);
                self = this;
                ProductConfig = InitShoppingPage(window.rootVue.thisWindow.tag);
                ProductStoreName = ProductConfig.storeName;
                ProductConfig.initPageData();
                //this.ShoppingPage.SearchEntity.IsSystem = true;
                this.ShoppingPage.SearchPageData();
                this.ShoppingPage.initCustomerUsersID();
                 
                this.ShoppingPage.initProductTypeProductTypeID();
                


                this.ShoppingPage.ToUpdate = function(data) { //列表点击修改或查看
                    self.$router.push('/AddProduct/' + data.ID)
                }

               this.ShoppingPage.PrintProductIDS = function(data) { //列表点击修改或查看
                    self.IsPrint=true;
                }


                this.ShoppingPage.ToUpdateStatus = function(data) { //列表点击修改状态 或者状态删除
                    var store = self.ShoppingPage;
                    store.Table.OnPageChange(store.SearchEntity.PageIndex, self)
                }
                this.ShoppingPage.ToDelete = function(data) { //列表点击删除
                    var store = self.ShoppingPage;
                    store.Table.OnPageChange(store.SearchEntity.PageIndex, self)
                }
           
                
            },
            gets: gets,
            g: gets,
              GetMallListPage(callback) {
                      if($("#keyword option:selected")[0]){
                        self.selectValue = $("#keyword option:selected")[0].value; 
                      }
                      
                      var model={
                        ProductType:self.ProductTypeID
                      }
                      // model.ProductTypeID=self.ProductTypeID,
                      model[self.selectValue] = self.serachKey
                      ProductTypeRequest.ShopProductsPaging(function(d) { 
                          var arr = [];
                          self.TotalCount=d.TotalCount
                           self.PageCount=d.PageCount
                          
                          for (var i of d.Records) {
                              i.Text = i.EnName + "-" + i.CnName;
                              i.Value = i.ID;
                              i.Evaluate = Number(i.Evaluate) 
                              i.ProductUrl = self.Urlpath+i.ProductUrl
                              arr.push(i)
                          }
                          self.productsList = arr                 
                          if (callback) { callback(d) }
                      }, {
                          PageSize: self.PageSize,
                          PageIndex:self.PageIndex,
                          // ProductTypeID:self.ProductTypeID,
                           Model: model
                      })
                  },
          //列表添加产品按钮
          AddProduct(){
            if(this.multipleSelection.length==0){
              self.$message.error(gets("$请至少选择一个产品添加"))
              return
            }
            var datas = [
             
            ];
           
            this.multipleSelection.map(item=>{
              datas.push({ProductID:item.ID,SKU:item.SKU})
            })
               
                        ProductTypeRequest.AddMallCart(function(d) { 
                             if (d.Message == "OK") {
                                
                                    self.$message.success(gets("$操作成功"))
                                    // this.ShoppingPage.SearchPageData();
                                } else {
                                    self.$message.error(d.Message)
                                }
                            
                        }, {
                            datas
                        })
                  

          },
          handleSizeChange(val) {
            this.PageSize = val
            this.GetMallListPage()
            
          },
          handleCurrentChange(val) {
            
           self.PageIndex= val
           self.GetMallListPage()

          },
          searchProduct(search){
              
              // this.serachKey = ""
              self.GetMallListPage()
          },
          selectType(selectIndex,ProductTypeID){
              
              this.ProductTypeID = ProductTypeID
             this.currentSelectType = ProductTypeID
              
            self.GetMallListPage()
          },
          changeType(tabIndex){
            this.currentTabID = tabIndex
          },
          changeImg(item,index){
            this.hiddenBorder=true
            this.detailPic = this.Urlpath+ item.img
            this.currentImgID = index          
          },
          showLastPic(){
             if(this.currentImgID == 0){
                this.currentImgID=this.smallPic.length-1
                
             }else{
               this.currentImgID =  this.currentImgID-1
             }     
              this.detailPic = this.Urlpath+ this.smallPic[this.currentImgID].img
          },
          showNextPic(){
             if(this.currentImgID == this.smallPic.length-1){
                this.currentImgID=0
             }else{
               this.currentImgID =  this.currentImgID+1
             }
              this.detailPic = this.Urlpath+this.smallPic[this.currentImgID].img           
          },
          handleClose(done) {
              this.dialogVisible = false
          },
          
          showProductDetail(ID){
            this.currentImgID =0
            this.radio=0
            this.dialogVisible = true
            this.hiddenBorder = true
                    

                ProductTypeRequest.GetShopProductDetails(function(d) {
                      var arr = [];
                      d.Evaluate = Number(d.Evaluate)
                      // d.ProductUrl=d.ProductUrl.substring(0,d.ProductUrl.length-1);
                      self.ProductDetailsArr = d.ProductDetails
                      self.SpecificationID=self.ProductDetailsArr[0].ID
                      self.SpecificationSKU=self.ProductDetailsArr[0].SKU
                      d.ProductUrl = d.ProductUrl.split( ',' );
                      
                      var imgArr =[]
                      for (var i = 0; i < d.ProductUrl.length; i++) {
                       
                          var obj = {};
                         
                          obj.img = d.ProductUrl[i];
                          if(!obj.img==""){
                            imgArr.push(obj);
                          }
                          
                          
                      }
                       self.smallPic =  imgArr
                    
                      self.ProductDetail = d
                      self.detailPic = self.Urlpath+ self.smallPic[0].img

                         
                    // if (callback) { callback(d) }
                }, ID)
                  
          },
          LenChange() {
              window.$.cookie('LanguagesTag', this.Value)
              languageRequest.Change(function(d) {
                  window.location.reload()
              }, this.Value)

          },
          gets: gets,
          g: gets,
        },
    }
</script>


<style>

.CnNameColumn .cell{
    white-space: nowrap !important;
    cursor: pointer;
}
.detailTable .cell.el-tooltip{
  white-space: normal !important;
}
.creatPur{
  vertical-align: inherit;
  color: #c7864d;
  font-weight:700;
  font-size:16px;
  cursor:pointer;
}
.creatPur:hover{
  color: #ac7544;
}
.push-detail{
  display: flex;
  align-content: center;
  margin-bottom: 20px;
  justify-content: center;
}
.push-detail:last-child{
   margin-bottom: 0px;
}
.push-detail .productName{
  line-height: 23px;
  width: 220px;

}
.push-detail .productPricie{
  font-weight: bold;
  font-size: 16px;
  margin-left: 20px;
}
.push-detail .productPricie span{
  color: red;

}
.pushProduct  .push-text{
    font-size: 14px;
  }

.push-text .square{
  display: inline-block;
  width: 20px;
  height: 20px;
  background-color: #ff556b;
  color: #fff;
  font-weight: bold;
  font-size: 13px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10%;
  margin-right: 10px;
}
  .push-box-card {
    /* width: 480px; */
  }
.pushProduct{
  border:1px solid #e2e2e2;
  width: 350px;
  z-index: 3;
  position: fixed;
  bottom: 0;
  right: 0;
}





.hiddenPurPrice{
  color: red;
}
.detailsWrapper{
  padding: 10px 10px 10px 0px;
  border-top: 1px solid rgb(240, 240, 240);
 
  display: flex;
  margin-top: 30px;
}
.detailsTitle{
  width: 55px;
  line-height: 44px;
  color: #606266;
  margin-top: 3px;
}
.detailsCont table{
  width: 700px;
}
.detailsCont .tdHeight{
  line-height: 20px;
}
.detailsCont table tr{
  border-bottom: 1px solid rgb(240, 240, 240);
}

  .chooseBox  .el-radio__input.is-checked .el-radio__inner {
    border-color: rgb(249, 116, 66);
    background: rgb(249, 116, 66);
  }
 .chooseBox .el-radio__label{
   display: none;
 }
  .chooseBox .el-radio__inner{
    border-radius: 10%;
  }
.detailsCont table .productImg{
  width: 100px;
  cursor: pointer;
}
.detailsCont table .name{
  width: 150px;
}
.detailsCont table .EnName{
  width: 150px;
}
.detailsCont table .SKU{
  width: 180px;
}
.detailsCont table .price{
  width: 60px;
}
.detailsCont table .qulatity{
  width: 60px;
}
.detailsCont table .productImg img{
  width: 34px;
  height: 34px;
  border: 1px solid #fff;
  margin: 15px 0px;
}
.detailsCont table .productImg img:hover{
  border: 1px solid red;
}
  /* .headerNav{
    padding:8px 20px !important;
  } */
    html {
        background-color: #f2f2f2;
        color: #666;
    }
    .search-value-input{
      display: block;
      width: 100%;
      padding: .375rem .75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: .25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      height: 35px;
      font-size: 14px;
      border-radius: 100px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      outline: none;
      background: #FAFAFA;
    }
    /* 修改搜索框placeholder文字颜色 */
    .search-value-input::-webkit-input-placeholder{
        color:#ced4da;
    }
    .search-value-input::-moz-placeholder{   /* Mozilla Firefox 19+ */
        color:#ced4da;
    }
    .search-value-input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
        color:#ced4da;
    }
    .search-value-input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
        color:#ced4da;
    }
    .search-wrapper{
      display: flex;
       
    }
    .input-select{
      width: 138px;
      outline: none;
      background-color: #1976d2;
      color: #fff;
      cursor: pointer;
      padding-left: 10px;
    border: none;
    appearance: none; 
    -moz-appearance: none;
    -webkit-appearance: none;
      padding-right: 10px;
      position: relative;

    

    }
    .arrow{
      padding-right: 10px;
      position: absolute;
      right: 22px;
      top: 10px;
    }
    /* @-moz-document url-prefix() {
.input-select {
                -moz-appearance: none;
                appearance: none;
                background-image: url("../../assets/img/arrow.jpg");
                background-repeat: no-repeat;
                background-position: calc(100% - -4px) 50%;
                background-size: 27% auto;
                border-radius: 3px;
                padding: 0;
            }

} */
    .btn-group-right{
      border-top-right-radius: 100px;
      border-bottom-right-radius: 100px;
      background: #1976d2;
      border-color: #1976d2;
      cursor: pointer;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
      color: #fff;
      outline: none;
      border: none;
    }
    .type-wrapper{
     
      background: #FFFFFF;
      margin: 25px 0;
      padding: 12px;
      border: 0 solid rgba(120, 130, 140, 0.13);
      border-radius: 5px;
      box-shadow: 0 5px 20px rgba(0, 0, 0, 0.05);
    }
    .type-select{
      display: flex;
      /* justify-content: space-between; */
      flex-wrap: wrap;
    }
    .type-title{
      height: 30px;
      line-height: 30px;
      border-bottom: 1px solid #d8d6d6;
      color: #007bff;
      font-size: 14px;
      margin-bottom: 10px;
    }
    .select-list{
      display: flex;
      align-items: center;
      padding: 10px;
      width: 400px;
    }

     .detailsCont{
        width: 100%;
     }
    .select-list i{
      color: #ced4da;
      margin-right: 5px;
      font-size: 16px;
      cursor: pointer;
    }
    .select-list div{
      font-size: 14px;
      color: #607d8b;
      cursor: pointer;
    }
    .selectTypeClass{
      color: #ff556b !important;
    }
    .tabBar{
      display: flex;
      border-bottom: 1px solid #dee2e6;
      margin-bottom: 20px;
    }
    .tab-child{
      display: flex;    
      align-items: center;  
      color: #007bff;
      padding: .5rem 1rem;
      font-size: 14px;
      cursor: pointer;

    }
    .tab-child:hover{
       color: #fff;
      border-color: transparent;
      background-color: #1976d2;
      /* border: 1px solid transparent; */
    }
    .tab-child-link{
      color: #fff;
      border-color: transparent;
      background-color: #1976d2;
      /* border: 1px solid transparent; */
      border-top-left-radius: .25rem;
      border-top-right-radius: .25rem;
    }
    .tab-child i{
      margin-right: 5px;
      font-size: 18px;
    }


    .mall-product{
      cursor: pointer;
    }
    .card-wrapper{
      margin: 40px 0px 0px;
    }
    .card-header-text{
      font-weight: bold;
      margin-top:10px;
      display: inline-block;
    }
    .recommend-box {
      -ms-flex-negative: 0;
      flex-shrink: 0;
      float: left;
      background-color: #f5f5f5;
      width: 24%;
      margin: 0 0 20px 12px;
    }

    .products{
      border-radius: 8px 8px 0 0;
      overflow: hidden;
    }
    .products .products-mainpic {
      position: relative;
      width: 100%;
      padding-top: 100%;
      height: 0;
      overflow: hidden;
    }
    .products .products-mainpic>img {
      position: absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%,-50%);
      transform: translate(-50%,-50%);
      display: block;
      width: 100%;
      height: 100%;
      margin: 0 auto;
    }
  .products .products-detail {
      padding: 8px 12px 14px;
      position: relative;
      line-height: 40px;
  }
.products-detail .products-title {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: #000;
    font-size: 12px;
    line-height: 14px;
    width: 100%;
    -webkit-transform-origin: left center;
    transform-origin: left center;
    max-height: 14px;
    margin-bottom: 6px;
    margin-top: 10px;
}
.products-price {
    font-weight: 700;
    font-family: OpenSans,Open Sans,Arial,Helvetica,sans-serif;
    line-height: 18px;
    max-height: 18px;
    margin-right: -4px;
    padding-right: 4px;
    font-size: 19px;
    color: #f97442;
    padding: 10px 0px 40px 0px;
}
 .recommend-ranking {
    border-radius: 0 0 8px 8px;
    
    padding: 12px 0px;
    display: flex;
        justify-content: flex-end;
   
}
.ranking-name{
   background: #ff556b;
    color: #FFF;
    font-size: 13px;
        width: 125px;
    text-align: center;
    border-radius: 5px;
    line-height: 30px;
    height: 30px;
    text-transform: capitalize;
    transition: all 0.5s ease;
    cursor: pointer;
}
.ranking-name:hover{
  background: #ca4657;
}


.product-main-wrap {
    position: relative;
    /* width: 930px; */
    margin: 0 auto;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    /* padding-bottom: 50px; */
}
.img-view-wrap {
    position: relative;
    width: 450px;
    -ms-flex-preferred-size: 450px;
    flex-basis: 450px;
    -ms-flex-negative: 0;
    flex-shrink: 0;
}
.product-info {
    -ms-flex-preferred-size: 550px;
    flex-basis: 550px;
    -ms-flex-positive: 1;
    -webkit-flex-grow: 1;
    flex-grow: 1;
    margin-left: 32px;
}
.image-viewer {
    width: 100%;
    display: flex;
    /* overflow: hidden; */
    background-color: #fff;
}
.image-viewer #poster{
    width: 450px;
}

.image-view-magnifier-wrap {
    position: relative;
    width: 450px;
    height: 450px;
    overflow: hidden;
    cursor: pointer;
    text-align: center;
    direction: ltr;
    display: none;
}
.image-view-magnifier-wrap .magnifier-loading-wrap {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: none;
}
.image-view-magnifier-wrap .magnifier-loading-wrap .magnifier-loading-cover {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background: #fff;
    opacity: .4;
}
.image-view-magnifier-wrap .magnifier-loading-wrap .magnifier-loading {
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
    background: url(data:image/gif;base64,R0lGODlhIAAgAPcAAP///7Ozs/v7+9bW1uHh4fLy8rq6uoGBgTQ0N…CAUoQEmkp1aFDqggJCrQ4kMACrwKhOCQ4Yy1Kg14EFxg4o61At24Rcx9ZUm1NuzgJvAwIAOw==) 50% 50% no-repeat;
}
.image-view-magnifier-wrap .magnifier-cover {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
}
.images-view-wrap {
    width: 100%;
    overflow-x: auto;
}
.images-view-wrap .images-view-list {
    background-color: #fff;
    padding: 0;
    margin: 15px 0 20px;
    list-style-type: none;
    text-align: center;
}
.images-view-wrap .images-view-list li {
    display: inline-block;
    vertical-align: middle;
    box-shadow: inset 0 0 0 1px #ccc;
    border-radius: 3px;
    cursor: pointer;
    margin-right: 11px;
}
.images-view-wrap .images-view-list li .images-view-item {
    width: 54px;
    height: 54px;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    position: relative;
}
.images-view-wrap .images-view-list li .images-view-item img {
    max-width: 50px;
    max-height: 50px;
}
.images-view-wrap .images-view-list li .images-view-item .play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    display: inline-block;
    width: 16px;
    height: 16px;
    margin: -8px 0px 0px -8px;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAAABGdBT…fBS/fprCPJBUgGEnmYTgAzksOgB+MDyo2BDlqyTz92/g8m0Ge3W1ul7gAAAABJRU5ErkJggg==) 0% 0% / contain no-repeat;
    background-repeat: no-repeat;
}
.product-main-wrap {
    position: relative;
    /* width: 1200px; */
    margin: 0 auto;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}
.arrowBtn{
      display: block;
    width: 15px;
    border: 1px solid #ddd;
    height: 60px;
    line-height: 60px;
    background: #eee;
    text-align: center;
    font-size: 18px;
    position: absolute;
    left: 0;
    top: 10px;
    text-decoration: none;
    color: #999;
    margin-top: 20px;
    cursor: pointer;
}
.shownext{
  left: auto;
    right: 0;
}
.small-pic{
  width: 100%;
  text-align: center;
  padding-top: 30px;
}
.small-pic span{
  width: 68px;
  height: 68px;
  /* border: 1px solid #f60; */
  display: inline-block;
}
.small-pic img{
  width: 64px;
  height: 64px;
  cursor: pointer;
}
.videoWidth{
  width: 450px;
}

     @media only screen and (max-width:1800px) {
       .aaa{
         width: 130%;
       }
        .select-list{
          display: flex;
          align-items: center;
          padding: 10px;
          width: 437px;
        }
        .recommend-box{
          width: 320px;
        }
        .image-viewer #poster{
          width: 100%;
          
        }
        .image-viewer{
          width: 38%;
        }
        .product-info{
          width: 55%;
          margin-left: 20px;
        }
        .detailsCont table{
          width: 520px;
        }
        .detailsCont table .salePriceTable{
          width: 70px;
        }
        .videoWidth{
          width: 100%;
        }
        .img-view-wrap{
          width: 100%;
          flex-basis: 370px;
        }
        .product-main-wrap{
          width: 100%;
        }
     }
       @media only screen and (max-width:1600px) {
         .aaa{
           width: auto;
         }
        .select-list{
          display: flex;
          align-items: center;
          padding: 10px;
          width: 437px;
        }
        .recommend-box{
          width: 310px;
        }
        .image-viewer #poster{
          width: 100%;
          
        }
        .image-viewer{
          width: 38%;
        }
        .product-info{
          width: 55%;
          margin-left: 20px;
        }
        .detailsCont table{
          width: 520px;
        }
        .detailsCont table .salePriceTable{
          width: 70px;
        }
        .videoWidth{
          width: 100%;
        }
        .img-view-wrap{
          width: 100%;
          flex-basis: 370px;
        }
        .product-main-wrap{
          width: 100%;
        }
     }
</style>



// WEBPACK FOOTER //
// MyShoppingMall.vue?1e287dac